import React from 'react';

import { Box } from 'Components/Base';

import { useClearByLearnEd } from '../Contexts/ClearByLearnEdProvider/ClearByLearnEdProvider';
import ClearTicketFormView from '../Components/ClearTicketForm';

import ClearByLearnEdUploadImage from './ClearImageUpload';

const ClearTicketForm = (props) => {
  const [, { courseName, videoTitle, videoTime, question } = {}, { goToReviewingStep }] =
    useClearByLearnEd();

  return (
    <ClearTicketFormView
      onSubmit={goToReviewingStep}
      initialValues={{ courseName, videoTitle, videoTime, question }}
      {...props}
    >
      <Box mb={7}>
        <ClearByLearnEdUploadImage />
      </Box>
    </ClearTicketFormView>
  );
};

export default ClearTicketForm;
